// extracted by mini-css-extract-plugin
module.exports = {"errorText":"CreateCampaignModal-module__errorText___23EJs","modalContent":"CreateCampaignModal-module__modalContent___21i7G"};